import Nprogress from 'nprogress'

import store from '@/store/store'

import { SALES_CHANNEL_TYPE } from '@/constants/salesChannels'

export default function retailerSalesChannelControl(to, from, next) {
  store.dispatch('retailerAuth/getUser').then(response => {
    if (response.retailer.sales_channels.length === 0) {
      if (to.name === 'retailer.information') {
        Nprogress.done()
        next()
        return
      }

      if (to.meta && typeof to.meta.allowWithoutSalesChannels === 'function') {
        if (to.meta.allowWithoutSalesChannels(response.retailer)) {
          Nprogress.done()
          next()
          return
        }
      }
      
      next({
        name: 'retailer.information'
      })
    } else {
      let hasForwardSalesChannel = response.retailer.sales_channels.some(
        sales_channel => sales_channel.id === SALES_CHANNEL_TYPE.FORWARD_SALE
      )

      if (to.name === 'retailer.information' && hasForwardSalesChannel === true) {
        next({
          name: 'retailer.dashboard'
        })
      } else {
        next()
      }
    }
  })
}
